import type { UploadFile } from 'antd';

import { getAxiosWithAuth } from '@/lib/axios';

export const getUploadFilePath = async (file: File, type: string) => {
  const axios = getAxiosWithAuth();
  const formData = new FormData();
  formData.append('files', file);
  const { data } = await axios.post(`/newUploads?type=${type}`, formData);
  const result = data?.[0]?.showPath;
  if (typeof result !== 'string') {
    throw new Error('上傳失敗');
  }
  return result;
};

/**
 * 該函數目前只能處理一張圖片的情況，待之後擴展功能，邏輯可修改，但請確保原本功能一切正常
 * @param imageFileList 用 Ant Design 的 Upload 元件上傳圖片後得到的 fileList
 * @returns imageUrl
 */
export const getUploadFileImageUrl = (imageFileList: UploadFile[] | null) => {
  const imgPlaceHolderPath = '/noImage.svg';

  if (!imageFileList || imageFileList.length === 0) {
    return imgPlaceHolderPath;
  }
  const imageFile = imageFileList[0];
  return imageFile.thumbUrl || imageFile.url || imgPlaceHolderPath;
};
